import { memo } from 'react';
import { Lozenge } from 'shared/lozenge/Lozenge';

type StatusLozengeProps = Readonly<{
    status?: string;
    color: string;
}>;

function StatusLozenge({ status, color }: StatusLozengeProps) {
    return (
        <div>
            <Lozenge color="var(--text-on-color)" backgroundColor={color}>
                {status?.toUpperCase()}
            </Lozenge>
        </div>
    );
}

const memoStatusLozenge = memo(StatusLozenge);
export { memoStatusLozenge as StatusLozenge };
